import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Products } from '@app/_models';
import { environment } from '@environments/environment';


@Injectable({
    providedIn: 'root'
})
export class MakeOfferService {

    constructor(private http: HttpClient) { }


    makeOffer(params){
        return this.http.post<any>(`${environment.apiUrl}/make-offers/offer`,params);
    }

}


